/* ESA storefront behaviour (P5): state choice, chip, eligibility badges, scoped search.
   Plain JS, no dependencies. The chosen state lives in localStorage ("esa.state") and is
   mirrored to cart attributes so the checkout/funnel (P6) can read it. */
(function () {
  'use strict';
  var KEY = 'esa.state';
  var ESA = (window.ESA = window.ESA || {});
  // The layout loads this file site-wide and the ESA sections also load it for
  // stand-alone use; run the initialisation once no matter how many tags exist.
  if (ESA.__loaded) { return; }
  ESA.__loaded = true;

  // Short program names for badges and the chip (design: "Billable to TEFA").
  var SHORT = { al: 'Alabama CHOOSE', ar: 'Arkansas EFA', az: 'Arizona ESA', fl: 'Florida FES/PEP',
    ga: 'Georgia Promise', ia: 'Iowa ESA', id: 'Idaho tax credit', in: 'Indiana ESA', la: 'Louisiana GATOR',
    mo: 'MOScholars', ms: 'Mississippi ESA', nc: 'NC ESA+', nh: 'NH EFA', sc: 'SC ESTF', tn: 'Tennessee EFS',
    tx: 'TEFA', ut: 'Utah Fits All', wv: 'WV Hope', wy: 'Wyoming ESA',
    'tx-pdses': 'Texas PDSES', ny: 'NYC Scholarship', mn: 'Minnesota K-12 credit' };
  // Tax-benefit states (no approval, family claims on its state return): 'May qualify' wording.
  var TAX = { id: 'Idaho', mn: 'Minnesota' };
  var STATUS = { approved: 'Approved vendor', pending: 'Application pending', not_applied: 'Coming soon',
    card: 'Pay by card, then claim' };   // card: nothing to apply for, families claim it back (ID, MS)
  // How each program pays vendors, shown as the payment platform's logo on the state cards.
  var CW = { key: 'classwallet', file: 'esa-logo-classwallet.png', label: 'DirectPay via ClassWallet' };
  var OD = { key: 'odyssey', file: 'esa-logo-odyssey.svg', label: 'Odyssey marketplace' };
  var RAIL = { al: CW, ar: CW, az: CW, in: CW, nc: CW, sc: CW, nh: CW, 'tx-pdses': CW, ny: CW,
    tn: { key: 'theodore', file: '', label: 'Tennessee EFS portal' },
    mo: OD,
    tx: OD, ut: OD, ga: OD, ia: OD, la: OD, wy: OD,
    fl: { key: 'stepup', file: 'esa-logo-stepup.png', label: 'Step Up For Students MyScholarShop' },
    wv: { key: 'hope', file: 'esa-logo-hope.png', label: 'Hope Scholarship marketplace' } };
  // "Hardcover" inside a product card (the card itself is a link): open hardcover.app in a new tab.
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-hc-href]');
    if (!t) return;
    ev.preventDefault(); ev.stopPropagation();
    window.open(t.getAttribute('data-hc-href'), '_blank', 'noopener');
  }, true);
  document.addEventListener('keydown', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-hc-href]');
    if (t && (ev.key === 'Enter' || ev.key === ' ')) { ev.preventDefault(); window.open(t.getAttribute('data-hc-href'), '_blank', 'noopener'); }
  }, true);
  ESA.short = function (code) { return SHORT[code] || (code || '').toUpperCase(); };
  function keyOf(st) { return (st && (st.key || st.state)) || ''; }
  // Harmony Education Services (2026-11-02): its own logo (Harmony pays approved vendors through ClassWallet).
  var HM = { key: 'harmony', file: 'esa-logo-harmony.svg', label: 'Harmony Education Services (pays through ClassWallet)' };
  function railOf(st) { return st ? (st.harmony ? HM : (RAIL[keyOf(st)] || RAIL[st.state])) : null; }
  // A program entry with a "url" (Harmony) is a plain link: it does not set the state, so badges and the
  // chip stay on the state's own program rules.
  ESA.go = function (st) { if (st.url) { window.location.href = st.url; } else { ESA.choose(st.state, keyOf(st)); } };
  // One entry per state, its programs in list order (Sam 2026-11-02: one card per state, then pick the program).
  function byState(list) {
    var map = {}, out = [];
    list.forEach(function (st) {
      if (!map[st.state]) { map[st.state] = { state: st.state, name: st.name, programs: [] }; out.push(map[st.state]); }
      map[st.state].programs.push(st);
    });
    return out.sort(function (a, b) { return a.name.localeCompare(b.name); });
  }
  function railLogos(programs, flagBase) {
    var seen = {}, imgs = [];
    programs.forEach(function (st) {
      var rail = railOf(st);
      if (!rail || !rail.file || !flagBase || seen[rail.key]) return;
      seen[rail.key] = 1;
      var logo = document.createElement('img');
      logo.className = 'esa-card__rail esa-card__rail--' + rail.key;
      logo.src = flagBase + rail.file; logo.alt = rail.label; logo.title = rail.label; logo.loading = 'lazy';
      imgs.push(logo);
    });
    return imgs;
  }
  // Pop-up copy (snippets/esa-program-copy.liquid): what each program pays for.
  function programDetail() {
    var copy = ESA.programCopy || {}, cats = {};
    (copy.cats || '').split(/\n/).forEach(function (line) {
      var i = line.indexOf('|'); if (i > 0) cats[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
    return { cats: cats, cta: copy.cta, catsLabel: copy.catsLabel, never: copy.never };
  }
  function statusPill(st) {
    var pill = document.createElement('span');
    var ok = st.status === 'approved';
    pill.className = 'esa-badge ' + (ok || st.status === 'card' ? 'esa-badge--approved' : 'esa-badge--pending');
    pill.textContent = ok ? ((ESA.copy && ESA.copy.approved) || STATUS.approved) : (STATUS[st.status] || STATUS.pending);
    return pill;
  }
  // "Which program are you ordering through?" for a state with more than one program. With "detail" (the
  // scholarship-programs page) each program also shows what it pays for and its own Shop button.
  function chooseProgram(group, flagBase, detail) {
    var d = document.getElementById('esa-choose');
    if (!d) {
      d = document.createElement('dialog'); d.id = 'esa-choose'; d.className = 'esa-choose';
      d.innerHTML = '<button type="button" class="esa-choose__close" aria-label="Close">&times;</button>' +
        '<h2 class="esa-choose__title"></h2><p class="esa-choose__sub"></p><div class="esa-choose__list"></div>';
      d.querySelector('.esa-choose__close').addEventListener('click', function () { d.close(); });
      d.addEventListener('click', function (ev) { if (ev.target === d) d.close(); });
      document.body.appendChild(d);
    }
    d.querySelector('.esa-choose__title').textContent = group.name;
    d.querySelector('.esa-choose__sub').textContent = detail
      ? (group.programs.length > 1 ? 'Programs we work with in ' + group.name : 'The program we work with in ' + group.name)
      : ((ESA.copy && ESA.copy.choose) || 'Which program are you ordering through?');
    var box = d.querySelector('.esa-choose__list'); box.innerHTML = '';
    group.programs.forEach(function (st) {
      var b = document.createElement(detail ? 'div' : 'button'); b.className = 'esa-choose__opt' + (detail ? ' esa-choose__opt--detail' : '');
      if (!detail) b.type = 'button';
      var n = document.createElement('span'); n.className = 'esa-choose__name'; n.textContent = st.program; b.appendChild(n);
      railLogos([st], flagBase).forEach(function (img) { b.appendChild(img); });
      if (detail || st.status === 'approved') b.appendChild(statusPill(st));
      if (detail) {
        var lab = document.createElement('span'); lab.className = 'esa-choose__label'; lab.textContent = detail.catsLabel || 'Books this program pays for'; b.appendChild(lab);
        var c = document.createElement('span'); c.className = 'esa-choose__cats';
        c.textContent = detail.cats[keyOf(st)] || (st.harmony && detail.cats.harmony) || detail.cats[st.state] || ''; b.appendChild(c);
        var go = document.createElement('a'); go.className = 'esa-choose__shop button';
        go.href = st.url || '/collections/esa-' + st.state;
        go.textContent = st.harmony ? 'Shop Harmony ' + st.name + ' books' : (detail.cta || 'Shop [state] books').replace('[state]', st.name);
        go.addEventListener('click', function (ev) { ev.preventDefault(); d.close(); ESA.go(st); });
        b.appendChild(go);
      } else {
        b.addEventListener('click', function () { d.close(); ESA.go(st); });
      }
      box.appendChild(b);
    });
    var nv = d.querySelector('.esa-choose__never');
    if (detail && detail.never) {
      if (!nv) { nv = document.createElement('p'); nv.className = 'esa-choose__never'; d.appendChild(nv); }
      nv.textContent = detail.never; nv.hidden = false;
    } else if (nv) { nv.hidden = true; }
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  }

  function readStates(el) {
    try { return JSON.parse((el && el.getAttribute('data-esa-states')) || '[]'); } catch (e) { return []; }
  }
  function allStates() {
    var el = document.querySelector('[data-esa-states]');
    return readStates(el);
  }
  function chosen() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function programFor(code, key) {
    var list = allStates(), cur = chosen();
    if (!key && cur && cur.state === code && cur.key) key = cur.key;
    if (key) for (var j = 0; j < list.length; j++) if (keyOf(list[j]) === key) return list[j];
    for (var i = 0; i < list.length; i++) if (list[i].state === code) return list[i];
    return null;
  }
  function setCartAttributes(st) {
    var attrs = st ? { esa_state: st.state, esa_key: keyOf(st), esa_program: st.program, esa_rail: st.rail || '' }
                   : { esa_state: '', esa_key: '', esa_program: '', esa_rail: '' };
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  ESA.choose = function (code, key) {
    var st = programFor(code, key);
    if (!st) return;
    localStorage.setItem(KEY, JSON.stringify({ state: st.state, key: keyOf(st), name: st.name, program: st.program, rail: st.rail }));
    setCartAttributes(st).then(function () {
      var path = ((ESA.copy && ESA.copy.portalPath) || '/collections/esa-{state}').replace('{state}', st.state);
      // "Not your state?" on the cart sends the parent here with esa_return=/cart
      var back = null;
      try { back = new URLSearchParams(window.location.search).get('esa_return'); } catch (e) {}
      if (back && back.charAt(0) === '/' && back.charAt(1) !== '/') path = back;
      window.location.href = path;
    });
  };
  ESA.clear = function () { localStorage.removeItem(KEY); setCartAttributes(null); };

  /* ---- picker cards ---- */
  function renderPicker() {
    var grid = document.querySelector('[data-esa-picker] .esa-picker__grid');
    var tpl = document.getElementById('esa-card-template');
    if (!grid || !tpl || grid.getAttribute('data-esa-rendered')) return;
    grid.setAttribute('data-esa-rendered', '1');
    var copy = ESA.copy || {};
    var flagBase = grid.getAttribute('data-flag-base');
    byState(readStates(grid)).forEach(function (g) {
      var card = tpl.content.firstElementChild.cloneNode(true);
      var first = g.programs[0], one = g.programs.length === 1;
      card.setAttribute('data-state', g.state);
      if (flagBase) { card.style.setProperty('--esa-flag', 'url("' + flagBase + 'esa-flag-' + g.state + '.png")'); }
      card.href = one && first.url ? first.url : ((copy.portalPath) || '/collections/esa-{state}').replace('{state}', g.state);
      card.querySelector('.esa-card__name').textContent = g.name;
      var prog = card.querySelector('.esa-card__program');
      g.programs.forEach(function (st, i) {
        if (i) prog.appendChild(document.createElement('br'));
        prog.appendChild(document.createTextNode(st.program));
      });
      var badge = card.querySelector('.esa-card__status');
      railLogos(g.programs, flagBase).forEach(function (img) { badge.insertAdjacentElement('beforebegin', img); });
      // Only approved programs carry a pill (Sam, 2026-10-04: no "Application pending" on the cards).
      if (g.programs.some(function (st) { return st.status === 'approved'; })) {
        badge.textContent = copy.approved || STATUS.approved;
        badge.classList.add('esa-badge--approved');
      } else if (badge && g.programs.some(function (st) { return st.status === 'card'; })) {
        badge.textContent = STATUS.card;   // green like Approved vendor (Sam 2026-11-03)
        badge.classList.add('esa-badge--approved');
      } else if (badge) { badge.remove(); }
      card.addEventListener('click', function (ev) {
        ev.preventDefault();
        chooseProgram(g, flagBase, programDetail());   // same pop-up as the programs page (Sam 2026-11-02)
      });
      grid.appendChild(card);
    });
  }

  /* ---- header chip ---- */
  function renderChip() {
    var chip = document.querySelector('[data-esa-chip]');
    if (!chip) return;
    var st = chosen();
    if (!st) { chip.hidden = true; return; }
    // phones hide the state name (".esa-chip__state") and keep the program: "Arizona ESA"
    var lab = chip.querySelector('[data-esa-chip-label]');
    lab.innerHTML = '';
    var sn = document.createElement('span'); sn.className = 'esa-chip__state'; sn.textContent = st.name + ' · ';
    lab.appendChild(sn); lab.appendChild(document.createTextNode(ESA.short(keyOf(st))));
    chip.hidden = false;
  }

  /* ---- portal header ---- */
  function renderPortal() {
    var p = document.querySelector('[data-esa-portal]');
    if (!p) return;
    var code = p.getAttribute('data-state');
    var st = programFor(code);
    var copy = ESA.copy || {};
    if (st) {
      var name = p.querySelector('[data-esa-program-name]'); if (name) name.textContent = st.program;
      var rail = p.querySelector('[data-esa-rail-copy]');
      if (rail) rail.textContent = st.marketplace && !st.directpay ? ('Marketplace: ' + st.rail) : (st.directpay ? ('DirectPay via ' + st.rail) : st.rail);
      var eyebrow = p.querySelector('[data-esa-state-eyebrow]');
      if (eyebrow) eyebrow.textContent = st.name + ' · scholarship program';
      p.querySelectorAll('[data-esa-row-label][data-suffix="popular"]').forEach(function (h) { h.textContent = 'Homeschool Favorites for ' + st.name + ' Families'; });
      // landing on a portal page counts as choosing that state
      var cur = chosen();
      if (!cur || cur.state !== st.state) {
        localStorage.setItem(KEY, JSON.stringify({ state: st.state, key: keyOf(st), name: st.name, program: st.program, rail: st.rail }));
        setCartAttributes(st);
        refreshBadges(); renderChip();
      }
      // show the tab that applies to this rail first
    }
    p.querySelectorAll('[data-esa-tab]').forEach(function (b) {
      b.addEventListener('click', function () { activateTab(p, b.getAttribute('data-esa-tab')); });
    });
    initGradePick(p);
  }
  /* ---- grade chooser on the state page: one grade for every collection in the store ---- */
  var GRADE_PARAM = 'filter.p.m.esa.grades';
  function chosenGrade() { return (sticky()[GRADE_PARAM] || [])[0] || ''; }
  function setGrade(g) {
    var cur = sticky();
    cur[GRADE_PARAM] = g ? [g] : [];
    cur['filter.p.m.bookscloud.ages'] = [];
    try { localStorage.setItem('esa.sticky', JSON.stringify(cur)); } catch (e) {}
  }
  // Grade -> the grade-band collection key (tools/esa_grade_bands.py)
  // Subjects with single-grade pages (tools/esa_grade_pages.py); the rest filter by grade.
  var GRADE_PAGED = ['reading', 'science', 'social-studies', 'languages', 'awards', 'arts', 'life-skills', 'computer-science', 'math', 'workbooks', 'curriculum'];
  function gradeSlug(g) { return g === 'Pre-K' ? 'pre-k' : g === 'K' ? 'k' : String(g).replace('Grade ', ''); }
  function gradeUrl(handle, suffix, g) {
    if (GRADE_PAGED.indexOf(suffix) !== -1 && !/-card$/.test(handle)) return '/collections/' + handle + '-grade-' + gradeSlug(g);
    return '/collections/' + handle + '?filter.p.m.esa.grades=' + encodeURIComponent(g);
  }
  var rowCache = {};
  function fetchRowItems(url) {
    if (!rowCache[url]) {
      var u = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=esa-row-items';
      rowCache[url] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var list = doc.querySelector('.esa-row-items');
          return { items: Array.prototype.slice.call(doc.querySelectorAll('.esa-row-items > li')),
                   count: list ? list.getAttribute('data-count') : null };
        }).catch(function () { return { items: [], count: null }; });
    }
    return rowCache[url];
  }
  function fitsGrade(li, g) { return (li.getAttribute('data-grades') || '').split('|').indexOf(g) !== -1; }
  function showRow(ul, g) {
    var per = Number(ul.getAttribute('data-per-row')) || 6, items = ul.querySelectorAll('.esa-grid__item'), n = 0;
    var own = Array.prototype.filter.call(items, function (li) { return !li.hasAttribute('data-esa-fetched'); });
    var pick;
    if (!g) pick = own;
    else {
      var fetched = Array.prototype.filter.call(items, function (li) { return li.getAttribute('data-esa-fetched') === g; });
      var fit = own.filter(function (li) { return fitsGrade(li, g); });
      pick = fetched.concat(fit.filter(function (li) { return fetched.indexOf(li) === -1; }));
      // too few books for this grade anywhere: keep the row full with its usual books
      if (pick.length < per) pick = pick.concat(own.filter(function (li) { return pick.indexOf(li) === -1; }));
    }
    items.forEach(function (li) { li.hidden = true; });
    pick.forEach(function (li) { if (n < per) { li.hidden = false; n++; } });
    ul.classList.add('is-graded');
  }
  // "See all N" and the row title follow the chosen grade.
  function setRowLinks(ul, url, count) {
    var head = ul.parentNode && ul.parentNode.querySelector('.esa-portal__rowhead');
    if (!head) return;
    head.querySelectorAll('a').forEach(function (a) {
      if (!a.hasAttribute('data-esa-href')) { a.setAttribute('data-esa-href', a.getAttribute('href')); a.setAttribute('data-esa-text', a.textContent); }
      a.setAttribute('href', url || a.getAttribute('data-esa-href'));
    });
    var all = head.querySelector('a:not(.esa-portal__rowlink)');
    if (all) all.textContent = (url && count !== null) ? ('See all ' + Number(count).toLocaleString() + ' →') : all.getAttribute('data-esa-text');
  }
  function applyGradeToRows(root, g) {
    root.querySelectorAll('.esa-grid[data-per-row]').forEach(function (ul) {
      showRow(ul, g);
      var handle = ul.getAttribute('data-handle') || '', suffix = ul.getAttribute('data-suffix') || '';
      if (!g) { setRowLinks(ul, null, null); return; }
      var url = gradeUrl(handle, suffix, g);
      fetchRowItems(url).then(function (res) {
        if (chosenGrade() !== g) return;
        var have = {};
        ul.querySelectorAll('[data-id]').forEach(function (li) { have[li.getAttribute('data-id')] = 1; });
        res.items.forEach(function (li) {
          var id = li.getAttribute('data-id');
          if (have[id]) { var mine = ul.querySelector('[data-id="' + id + '"]'); if (mine && !mine.hasAttribute('data-esa-fetched')) mine.setAttribute('data-esa-fetched', g); return; }
          have[id] = 1;
          var node = document.importNode(li, true);
          node.setAttribute('data-esa-fetched', g);
          ul.appendChild(node);
        });
        showRow(ul, g);
        // no books for this grade yet (grades fill in as tagging finishes): keep the row's own
        // link and count rather than "See all 0"
        if (res.count === null || Number(res.count) === 0) setRowLinks(ul, null, null);
        else setRowLinks(ul, url, res.count);
      });
    });
  }
  function initGradePick(root) {
    var box = root.querySelector('[data-esa-gradepick]');
    if (!box || box.getAttribute('data-esa-ready')) return;
    box.setAttribute('data-esa-ready', '1');
    var now = box.querySelector('[data-esa-gradepick-now]');
    function show() {
      var g = chosenGrade();
      box.querySelectorAll('[data-grade]').forEach(function (b) {
        var on = b.getAttribute('data-grade') === g;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (now) {
        now.hidden = false;
        now.textContent = g ? ('Showing books for ' + g + ' on every collection page. Choose another grade or "All grades" to change it.')
                            : 'No grade chosen: every collection shows all grades.';
      }
      applyGradeToRows(root, g);
    }
    box.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-grade]');
      if (!b) return;
      setGrade(b.getAttribute('data-grade'));
      show();
    });
    show();
  }
  function activateTab(root, name) {
    root.querySelectorAll('[data-esa-tab]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-esa-tab') === name); });
    root.querySelectorAll('[data-esa-panel]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-esa-panel') === name); });
  }

  /* ---- eligibility badges (product page + cards) ---- */
  // Pages can be shown from the back/forward cache or prerendered before a state change, so the
  // pills are redrawn whenever the chosen state differs from the one they were drawn for.
  var drawnFor = null;
  function refreshBadges() {
    var st = chosen(), key = st ? st.state : '';
    if (drawnFor === key) return;
    document.querySelectorAll('[data-esa-eligibility][data-esa-done]').forEach(function (el) {
      el.removeAttribute('data-esa-done');
      el.classList.remove('esa-elig--billable', 'esa-elig--card', 'esa-elig--unknown');
    });
    renderBadges();
  }
  function renderBadges() {
    var st = chosen();
    drawnFor = st ? st.state : '';
    document.querySelectorAll('[data-esa-eligibility]').forEach(function (el) {
      if (el.getAttribute('data-esa-done')) return;
      el.setAttribute('data-esa-done', '1');
      var states = (el.getAttribute('data-states') || '').split(',').filter(Boolean);
      var compact = el.classList.contains('esa-elig--compact');
      var others = states.filter(function (s) { return !st || s !== st.state; }).map(function (s) { return s.toUpperCase(); });
      var title, sub = '', cls;
      if (!st) {
        cls = 'esa-elig--unknown';
        title = compact ? 'Choose a state' : 'Choose your state to see if your program can pay';
        sub = states.length ? ('Billable in ' + states.length + ' program' + (states.length > 1 ? 's' : '') + '.') : '';
      } else if (states.indexOf(st.state) !== -1) {
        cls = 'esa-elig--billable';
        var reimb = !railOf(st);
        title = (TAX[st.state] ? 'May qualify for ' : (reimb ? 'Eligible for ' : 'Billable to ')) + ESA.short(keyOf(st));
        sub = (reimb ? (TAX[st.state] ? 'Pay by card; claim it on your ' + TAX[st.state] + ' tax return with our receipt.' : 'Pay by card; submit our receipt for reimbursement.') : 'Goes on your program invoice.') + (others.length ? ' Also billable in ' + others.slice(0, 8).join(', ') + (others.length > 8 ? ' and ' + (others.length - 8) + ' more.' : '.') : '');
      } else {
        cls = 'esa-elig--card';
        title = TAX[st.state] ? (compact ? 'Not expected to qualify' : 'Not expected to qualify for ' + ESA.short(keyOf(st))) : !railOf(st) ? (compact ? 'Not eligible' : 'Not eligible for ' + ESA.short(keyOf(st))) : (compact ? 'Pay by card' : 'Not billable to ' + ESA.short(keyOf(st)));
        sub = 'Pay by card in the same order.' + (others.length ? ' Billable in ' + others.slice(0, 8).join(', ') + '.' : '');
      }
      el.classList.add(cls);
      if (compact) {
        // dense grid view uses one word: Billable / Payable (Idaho and reimbursement programs keep their wording)
        var reim = st && !railOf(st);
        var short = cls === 'esa-elig--unknown' ? 'Choose a state'
          : cls === 'esa-elig--billable' ? (TAX[st.state] ? 'May qualify' : reim ? 'Eligible' : 'Billable')
          : (TAX[st.state] ? 'Not expected' : reim ? 'Not eligible' : 'Payable');
        el.innerHTML = '';
        var lg = document.createElement('span'); lg.className = 'esa-elig__long'; lg.textContent = title;
        var sh = document.createElement('span'); sh.className = 'esa-elig__short'; sh.textContent = short;
        el.appendChild(lg); el.appendChild(sh);
        return;
      }
      el.innerHTML = '';
      var icon = document.createElement('span'); icon.className = 'esa-elig__icon'; icon.setAttribute('aria-hidden', 'true');
      icon.textContent = cls === 'esa-elig--billable' ? '✓' : (cls === 'esa-elig--card' ? '□' : '•');
      var body = document.createElement('span'); body.className = 'esa-elig__body';
      var t = document.createElement('span'); t.className = 'esa-elig__title'; t.textContent = title;
      if (!st) {
        t.textContent = '';
        var pick = document.createElement('a'); pick.href = '/#choose-state'; pick.className = 'esa-elig__pick';
        pick.textContent = 'Choose your state'; t.appendChild(pick);
        t.appendChild(document.createTextNode(' to see if your program can pay'));
      }
      body.appendChild(t);
      if (sub) { var d = document.createElement('span'); d.className = 'esa-elig__sub'; d.textContent = sub; body.appendChild(d); }
      el.appendChild(icon); el.appendChild(body);
    });
  }

  /* ---- scoped search: RETIRED 2026-10-05 (Sam) ----
     Header search covers the whole catalog again, and the predictive popup stays on. Result cards
     still show Billable / Pay by card for the chosen program; a state page's own "Find the right
     books" box keeps its explicit state filter (esa-grid-head), shown as a removable chip on results. */
  function scopeSearch() {
    var st = chosen();
    if (!st) return;
    document.querySelectorAll('form[action="/search"], form[action$="/search"]').forEach(function (form) {
      if (form.querySelector('input[name="filter.p.m.esa.states_eligible"]')) return;
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'filter.p.m.esa.states_eligible'; h.value = st.state;
      form.appendChild(h);
      // predictive search cannot be filtered server-side: turn it off while a state is chosen
      var input = form.querySelector('input[type="search"], input[name="q"]');
      if (input) { input.setAttribute('autocomplete', 'off'); input.removeAttribute('data-predictive-search'); }
    });
    // Results are not hidden client-side: under the split checkout every book is sellable, and each
    // card's badge says Billable or Pay by card. The state filter above narrows results when wanted.
  }


  // Smoothly open and close a <details> row (programs page).
  function animateDetails(d) {
    var summary = d.querySelector('summary'), body = d.querySelector('.esa-program__body');
    if (!summary || !body || d.getAttribute('data-esa-anim')) return;
    d.setAttribute('data-esa-anim', '1');
    summary.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (d.getAttribute('data-esa-busy')) return;
      d.setAttribute('data-esa-busy', '1');
      var closing = d.open;
      if (!closing) d.open = true;
      var h = body.scrollHeight;
      var anim = body.animate(
        closing ? [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }]
                : [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
        { duration: 300, easing: 'cubic-bezier(0.33, 1, 0.68, 1)' });
      body.style.overflow = 'hidden';
      anim.onfinish = function () {
        if (closing) d.open = false;
        body.style.overflow = '';
        d.removeAttribute('data-esa-busy');
      };
    });
  }

  /* ---- choose-your-state page: what each program pays for, and a button that selects it ---- */
  function renderPrograms() {
    var root = document.querySelector('[data-esa-programs]');
    var list = root && root.querySelector('[data-esa-programs-list]');
    var tpl = document.getElementById('esa-program-row');
    if (!root || !list || !tpl || list.getAttribute('data-esa-rendered')) return;
    list.setAttribute('data-esa-rendered', '1');
    var detail = programDetail();
    var flagBase = root.getAttribute('data-flag-base') || '';
    // One row per state; a click opens the program pop-up (Sam 2026-11-02: show what we are accepted for and
    // what each program pays for, like the homepage chooser).
    byState(readStates(root)).forEach(function (g) {
      var row = tpl.content.firstElementChild.cloneNode(true);
      row.querySelector('.esa-program__name').textContent = g.name;
      var progEl = row.querySelector('.esa-program__program');
      g.programs.forEach(function (st) {
        var line = document.createElement('span'); line.className = 'esa-program__line';
        line.appendChild(document.createTextNode(st.program + ' '));
        line.appendChild(statusPill(st));
        progEl.appendChild(line);
      });
      var pay = row.querySelector('.esa-program__pay');
      var logos = railLogos(g.programs, flagBase);
      if (logos.length) logos.forEach(function (img) { pay.appendChild(img); });
      else { var r0 = railOf(g.programs[0]); pay.textContent = r0 ? r0.label : 'Pay by card, then claim'; }
      var body = row.querySelector('.esa-program__body'); if (body) body.remove();
      row.querySelector('summary').addEventListener('click', function (ev) {
        ev.preventDefault();
        chooseProgram(g, flagBase, detail);
      });
      if (flagBase) row.style.setProperty('--esa-flag', 'url("' + flagBase + 'esa-flag-' + g.state + '.png")');
      list.appendChild(row);
    });
  }


  /* ---- filter labels: stored codes -> words parents recognise ---- */
  var SUBJECTS = { arts: 'Arts & music', ela: 'Reading & language arts', life_skills: 'Life skills',
    math: 'Math', reference: 'Reference', science: 'Science', social_studies: 'History & social studies',
    test_prep: 'Test prep', world_languages: 'World languages', technology: 'Technology',
    health_pe: 'Health & PE', religion: 'Faith & religion', stationery: 'Blank notebooks & journals',
    computer_science: 'Computer science' };
  var STATE_NAMES = { al: 'Alabama', ar: 'Arkansas', az: 'Arizona', fl: 'Florida', ga: 'Georgia', ia: 'Iowa',
    id: 'Idaho', in: 'Indiana', la: 'Louisiana', mo: 'Missouri', ms: 'Mississippi', nc: 'North Carolina',
    nh: 'New Hampshire', sc: 'South Carolina', tn: 'Tennessee', tx: 'Texas', ut: 'Utah', wv: 'West Virginia',
    wy: 'Wyoming', mn: 'Minnesota', ny: 'New York' };
  var FACET_MAPS = { 'filter.p.m.esa.subject': SUBJECTS, 'filter.p.m.esa.states_eligible': STATE_NAMES };
  function relabelFacets() {
    // Language facet: "Language version" -> "Language", "ENG- English" -> "English" (Sam 2026-10-05)
    var langWord = function (t) { return t.replace(/^\s*[A-Z]{2,3}-\s*/, ''); };
    document.querySelectorAll('facet-remove-component').forEach(function (pill) {
      pill.childNodes.forEach(function (n) { if (n.nodeType === 3 && /^\s*[A-Z]{3}-\s/.test(n.textContent)) n.textContent = langWord(n.textContent); });
    });
    document.querySelectorAll('input[name="' + LANG_PARAM + '"]').forEach(function (input) {
      var label = input.id && document.querySelector('label[for="' + input.id + '"]');
      var span = label && (label.querySelector('.checkbox__label-text') || label);
      if (span && /^\s*[A-Z]{2,3}-\s/.test(span.textContent)) span.textContent = langWord(span.textContent);
    });
    document.querySelectorAll('.facets__label, .facets__summary, summary, h3, h4').forEach(function (h) {
      h.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim() === 'Language version') n.textContent = n.textContent.replace('Language version', 'Language'); });
    });
    document.querySelectorAll('facet-remove-component').forEach(function (pill) {
      pill.childNodes.forEach(function (n) {
        if (n.nodeType !== 3) return;
        var t = n.textContent.trim(), word = SUBJECTS[t] || STATE_NAMES[t];
        if (word) n.textContent = n.textContent.replace(t, word);
      });
    });
    Object.keys(FACET_MAPS).forEach(function (name) {
      var map = FACET_MAPS[name];
      document.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        var word = map[input.value]; if (!word) return;
        var label = input.id && document.querySelector('label[for="' + input.id + '"]');
        var span = label && (label.querySelector('.checkbox__label-text') || label);
        if (span && span.textContent.trim() === input.value) span.textContent = word;
      });
      // the summary line under each facet heading ("ela, math")
      var param = name.replace(/\./g, '-');
      document.querySelectorAll('[data-filter-param-name="' + param + '"] .facets__status [ref="facetStatus"]').forEach(function (el) {
        var parts = el.textContent.split(',').map(function (x) { return x.trim(); });
        var out = parts.map(function (x) { return map[x] || x; }).join(', ');
        if (out !== el.textContent.trim() && parts.some(function (x) { return map[x]; })) el.textContent = out;
      });
    });
  }


  /* ---- cart: move a book between "Billed to program" and "Pay by card" ----
     Drag a row onto the other group (desktop) or use the "instead" button (touch). The choice is
     stored as the hidden line property _esa_pay, which the cart Liquid and the funnel read. */
  function moveLine(row, target) {
    if (!row || row.getAttribute('data-esa-pay') === target) return;
    var props = {};
    try { props = JSON.parse(row.getAttribute('data-esa-props') || '{}') || {}; } catch (e) {}
    if (Array.isArray(props) || typeof props !== 'object') props = {};  // Liquid renders empty properties as []
    props._esa_pay = target;
    row.classList.add('esa-cart-moving');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: row.getAttribute('data-key'), quantity: Number(row.getAttribute('data-esa-qty') || 1), properties: props }) })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function () { location.reload(); })
      .catch(function () { row.classList.remove('esa-cart-moving'); });
  }
  var dragKey = null;
  function initCartMove() {
    if (document.documentElement.getAttribute('data-esa-cart-move')) return;
    document.documentElement.setAttribute('data-esa-cart-move', '1');
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-esa-move]');
      if (!b) return;
      ev.preventDefault();
      moveLine(b.closest('tr[data-esa-pay]'), b.getAttribute('data-esa-move'));
    }, true);
    document.addEventListener('dragstart', function (ev) {
      var row = ev.target.closest && ev.target.closest('tr[data-esa-pay]');
      if (!row) return;
      dragKey = row.getAttribute('data-key');
      row.classList.add('esa-cart-dragging');
      try { ev.dataTransfer.effectAllowed = 'move'; ev.dataTransfer.setData('text/plain', dragKey); } catch (e) {}
      document.querySelectorAll('.esa-cart-group').forEach(function (g) {
        if (g.getAttribute('data-esa-group') !== row.getAttribute('data-esa-pay')) g.classList.add('esa-cart-drop');
      });
    }, true);
    document.addEventListener('dragend', function () {
      dragKey = null;
      document.querySelectorAll('.esa-cart-dragging, .esa-cart-drop, .esa-cart-over').forEach(function (el) {
        el.classList.remove('esa-cart-dragging', 'esa-cart-drop', 'esa-cart-over');
      });
    }, true);
    function groupFor(el) {
      var tr = el.closest && el.closest('tr');
      if (!tr) return null;
      if (tr.hasAttribute('data-esa-group')) return tr.getAttribute('data-esa-group');
      return tr.getAttribute('data-esa-pay');
    }
    document.addEventListener('dragover', function (ev) {
      if (!dragKey) return;
      var g = groupFor(ev.target);
      if (!g) return;
      ev.preventDefault();
      document.querySelectorAll('.esa-cart-group').forEach(function (h) {
        h.classList.toggle('esa-cart-over', h.getAttribute('data-esa-group') === g);
      });
    }, true);
    document.addEventListener('drop', function (ev) {
      if (!dragKey) return;
      var g = groupFor(ev.target);
      if (!g) return;
      ev.preventDefault();
      var row = document.querySelector('tr[data-esa-pay][data-key="' + dragKey.replace(/"/g, '') + '"]');
      moveLine(row, g);
    }, true);
  }


  /* ---- collection / search pages ---- */
  var LANG_PARAM = 'filter.v.t.shopify.language-version';
  // Default filters on collection and search pages: English and In stock. Once the parent changes
  // one of them, that one is left alone for the rest of the visit.
  var AVAIL_PARAM = 'filter.v.availability';

  var STICKY = ['filter.p.m.esa.grades', 'filter.p.m.bookscloud.ages'];
  function sticky() { try { return JSON.parse(localStorage.getItem('esa.sticky') || '{}') || {}; } catch (e) { return {}; } }
  function saveSticky() {
    var u = new URL(location.href), cur = {};
    if (!document.querySelector(STICKY.map(function (p) { return 'input[name="' + p + '"]'; }).join(','))) return;
    STICKY.forEach(function (p) {
      var vals = u.searchParams.getAll(p);
      if (document.querySelector('input[name="' + p + '"]')) cur[p] = vals;   // this page offers it: its state wins
      else cur[p] = sticky()[p] || [];                                          // not offered here: keep the old choice
    });
    try { localStorage.setItem('esa.sticky', JSON.stringify(cur)); } catch (e) {}
  }
  function watchSticky() {
    if (document.documentElement.getAttribute('data-esa-sticky')) return;
    document.documentElement.setAttribute('data-esa-sticky', '1');
    // Horizon applies filters without reloading and rewrites the URL; save shortly after any change.
    var later = function () { setTimeout(saveSticky, 1500); };
    document.addEventListener('change', function (ev) {
      if (ev.target && STICKY.indexOf(ev.target.name) !== -1) later();
    }, true);
    document.addEventListener('click', function (ev) {
      if (ev.target.closest && ev.target.closest('facet-remove-component, .facets__clear, [href*="filter."], button[type="reset"]')) later();
    }, true);
    window.addEventListener('popstate', later);
  }

  /* ---- free-shipping progress bar (threshold: Theme settings > Free shipping bar) ----
     Shown under Add to cart on book pages, at the top of the cart page and in the cart drawer.
     Updates after any cart request (add / change / update / clear) the theme makes. */
  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function freeShipHtml(total) {
    var need = window.ESA_FREE_SHIP || 0;
    if (!need) return '';
    var left = Math.max(0, need - total), pct = Math.min(100, Math.round(total * 100 / need));
    var msg = left > 0
      ? 'You’re <strong>' + fmtMoney(left) + '</strong> away from <strong>free shipping</strong>. Add another book!'
      : '<strong>You’ve got free shipping!</strong>';
    return '<p class="esa-freeship__msg">' + msg + '</p><div class="esa-freeship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
  }
  var freeShipTotal = null;
  function paintFreeShip() {
    if (!window.ESA_FREE_SHIP) return;
    // placements: product form, cart page, cart drawer
    var spots = [];
    var form = document.querySelector('.product-details form[action*="/cart/add"], product-form-component form[action*="/cart/add"]');
    if (form) spots.push({ key: 'product', after: form });
    // cart page and cart drawer: just above "Estimated total"
    var drawer = document.querySelector('.cart-drawer__inner');
    var drawerTotal = drawer && drawer.querySelector('.cart-totals__container');
    if (drawerTotal) spots.push({ key: 'drawer', before: drawerTotal });
    else if (drawer) spots.push({ key: 'drawer', prepend: drawer });
    if (/\/cart\/?$/.test(location.pathname)) {
      var pageTotal = Array.prototype.filter.call(document.querySelectorAll('.cart-totals__container'), function (x) { return !(drawer && drawer.contains(x)); })[0];
      var cartPage = pageTotal || document.getElementById('esa-directpay') || document.querySelector('.cart-items, cart-items-component');
      if (cartPage) spots.push({ key: 'cart', before: cartPage });
    }
    spots.forEach(function (sp) {
      var el = document.querySelector('.esa-freeship[data-spot="' + sp.key + '"]');
      if (el && sp.before && el.nextElementSibling !== sp.before) { el.remove(); el = null; }
      if (!el) {
        el = document.createElement('div'); el.className = 'esa-freeship'; el.setAttribute('data-spot', sp.key);
        if (sp.after) sp.after.insertAdjacentElement('afterend', el);
        else if (sp.before) sp.before.insertAdjacentElement('beforebegin', el);
        else sp.prepend.insertAdjacentElement('afterbegin', el);
      }
      if (freeShipTotal !== null) el.innerHTML = freeShipHtml(freeShipTotal);
    });
  }
  function refreshFreeShip() {
    if (!window.ESA_FREE_SHIP) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) {
        freeShipTotal = c.items_subtotal_price || c.total_price || 0; paintFreeShip();
        // Step 1 sets esa_mode=directpay just before opening checkout; back on the store means that
        // checkout was left, so clear it (a card order must never get the program invoice email)
        if (c.attributes && c.attributes.esa_mode) clearProgramMode();
      })
      .catch(function () {});
  }
  function initFreeShip() {
    if (!window.ESA_FREE_SHIP || window.__esaFreeShip) return;
    window.__esaFreeShip = true;
    var realFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = realFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refreshFreeShip, 150); setTimeout(refreshSplit, 200); }, function () {});
      return p;
    };
    refreshFreeShip();
  }


  /* ---- two-step checkout: after the program checkout, the pay-by-card books come back ---- */
  function restoreCardStash() {
    var raw = null;
    try { raw = localStorage.getItem('esa.cardStash'); } catch (e) {}
    if (!raw || /\/checkouts?\//.test(location.pathname)) return;
    var items = []; try { items = JSON.parse(raw) || []; } catch (e) {}
    try { localStorage.removeItem('esa.cardStash'); } catch (e) {}
    if (!items.length) return;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { esa_mode: '' } }) });
      })
      .then(function () {
        // Step 2: take the parent to the cart, where a banner explains what to do next
        try { sessionStorage.setItem('esa.step2', '1'); } catch (e) {}
        if (!/\/cart\/?$/.test(location.pathname)) { location.href = '/cart'; return; }
        location.reload();
      })
      .catch(function () {});
  }

  /* ---- cart page: re-render the scholarship split section after any cart change ---- */
  var splitTimer = null;
  function refreshSplit() {
    var el = document.querySelector('[data-esa-split]');
    var wrap = el && el.closest('.shopify-section');
    if (!wrap || !wrap.id || !/\/cart\/?$/.test(location.pathname)) return;
    var id = wrap.id.replace(/^shopify-section-/, '');
    clearTimeout(splitTimer);
    splitTimer = setTimeout(function () {
      fetch('/cart?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d[id]) return;
          var tmp = document.createElement('div'); tmp.innerHTML = d[id];
          var fresh = tmp.querySelector('#' + CSS.escape(wrap.id)) || tmp.firstElementChild;
          if (fresh) wrap.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }, 100);
  }

  /* ---- card checkout from the cart: make sure the order is not flagged as a program order ---- */
  function clearProgramMode() {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { esa_mode: '' } }) }).catch(function () {});
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-esa-card-checkout]');
    if (!a) return;
    ev.preventDefault();
    var go = function () { window.location.href = a.getAttribute('href'); };
    var p = clearProgramMode();
    (p && p.then ? p.then(go, go) : go());
  });

  /* ---- cart page after Step 1: banner for Step 2 (pay-by-card books are back) ---- */
  function showStep2Banner() {
    var flag = null;
    try { flag = sessionStorage.getItem('esa.step2'); sessionStorage.removeItem('esa.step2'); } catch (e) {}
    if (!flag || !/\/cart\/?$/.test(location.pathname)) return;
    var main = document.querySelector('main') || document.body;
    var b = document.createElement('div');
    b.className = 'esa-step2-banner';
    b.setAttribute('role', 'status');
    var prog = '';
    try { prog = localStorage.getItem('esa.lastProgram') || ''; } catch (e) {}
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    b.innerHTML = '<p><strong>Step 1 is done: thank you!</strong> Your program order is placed. Please check your email and submit the invoice to ' +
      (prog ? 'the <strong>' + esc(prog) + '</strong>' : 'your state program') + ' so we can ship your order as soon as possible.</p>' +
      '<p><strong>Step 2:</strong> your pay-by-credit-card books are in your cart. Check them out by credit card below.</p>' +
      '<button type="button" class="esa-step2-banner__close" aria-label="Close">&times;</button>';
    b.querySelector('button').addEventListener('click', function () { b.remove(); });
    main.insertAdjacentElement('afterbegin', b);
  }
  function initNav() {
    if (!document.documentElement.getAttribute('data-esa-nav')) {
      document.documentElement.setAttribute('data-esa-nav', '1');
      document.addEventListener('click', function (ev) {
        var a = ev.target.closest && ev.target.closest('[data-esa-grade-link]');
        if (a) setGrade(a.getAttribute('data-esa-grade-link'));   // '' = All grades
        var pay = ev.target.closest && ev.target.closest('[data-esa-pay-link]');
        if (pay) {
          ev.preventDefault();
          var target = new URL(pay.getAttribute('href'), location.origin);
          if (pay.getAttribute('data-esa-tag')) target.pathname = target.pathname.replace(/\/$/, '') + '/' + pay.getAttribute('data-esa-tag');
          var cur = new URLSearchParams(location.search);
          cur.forEach(function (v, key) {
            if (key === 'page' || key === 'section_id') return;
            if (key === GRADE_PARAM) return;              // the grade is set by the link itself
            target.searchParams.append(key, v);
          });
          location.href = target.toString();
          return;
        }
        var k = ev.target.closest && ev.target.closest('[data-esa-keepquery]');
        if (k && location.search) {
          var q = new URLSearchParams(location.search); q.delete('page');
          var s = q.toString();
          if (s) { ev.preventDefault(); location.href = k.getAttribute('href') + '?' + s; }
        }
      }, true);
    }
    // Topics come from the collection's tags; count each one under the page's current grade and
    // filters and hide those with no books (e.g. Calculus on a Grade 5 page).
    var cur = new URLSearchParams(location.search); cur.delete('page');
    var topicLinks = Array.prototype.slice.call(document.querySelectorAll('[data-esa-nav] a.esa-nav__item[data-esa-topic]:not([data-esa-counted])'));
    var seen = {};
    (function next() {
      var a = topicLinks.shift();
      if (!a) return;
      a.setAttribute('data-esa-counted', '1');
      var href = a.getAttribute('href');
      var q = new URLSearchParams(cur.toString()); q.set('section_id', 'esa-row-items');
      var url = href + '?' + q.toString();
      var done = function (n) {
        document.querySelectorAll('[data-esa-nav] a.esa-nav__item[data-esa-topic][href="' + href + '"]').forEach(function (x) {
          if (n === 0 && !x.classList.contains('is-current')) { x.parentNode.hidden = true; return; }
          if (n !== null && !x.querySelector('span')) { var sp = document.createElement('span'); sp.textContent = Number(n).toLocaleString(); x.appendChild(sp); }
        });
        next();
      };
      if (seen[href] !== undefined) { done(seen[href]); return; }
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var m = /data-count="(\d+)"/.exec(html || '');
        seen[href] = m ? Number(m[1]) : null; done(seen[href]);
      }).catch(function () { done(null); });
    })();
    var topic = document.querySelector('.esa-nav__item.is-current[data-esa-topic]');
    if (topic && !document.documentElement.getAttribute('data-esa-titled')) {
      document.documentElement.setAttribute('data-esa-titled', '1');
      var label = topic.getAttribute('data-esa-topic');
      document.querySelectorAll('h1').forEach(function (h) { if (h.textContent.indexOf(label) !== 0) h.textContent = label + ' · ' + h.textContent.trim(); });
      document.title = label + ' · ' + document.title;
    }
  }
  function defaultEnglish() {
    var url = new URL(location.href), add = [];
    var off = function (k) { try { return sessionStorage.getItem('esa.off.' + k); } catch (e) { return null; } };
    var setOff = function (k) { try { sessionStorage.setItem('esa.off.' + k, '1'); } catch (e) {} };
    // the search-scope chips (esa-search-scope) and "Search the whole catalog" switch the defaults off
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('.esa-scope__chip[data-param], [data-esa-all]');
      if (!a) return;
      if (a.hasAttribute('data-esa-all')) { setOff(LANG_PARAM); setOff(AVAIL_PARAM); }
      else if (a.getAttribute('data-param') === LANG_PARAM || a.getAttribute('data-param') === AVAIL_PARAM) setOff(a.getAttribute('data-param'));
    }, true);
    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t && (t.name === LANG_PARAM || t.name === AVAIL_PARAM)) { try { sessionStorage.setItem('esa.off.' + t.name, '1'); } catch (e) {} }
    }, true);
    var langs = document.querySelectorAll('input[name="' + LANG_PARAM + '"]');
    // Language-study collections (e.g. Spanish) must not default to English-language books.
    var studyingLanguage = /-languages/.test(location.pathname);
    if (langs.length && !studyingLanguage && !url.searchParams.has(LANG_PARAM) && !off(LANG_PARAM)) {
      var en = null;
      langs.forEach(function (i) {
        var l = i.id && document.querySelector('label[for="' + i.id + '"]');
        if (!en && l && /english/i.test(l.textContent)) en = i;
      });
      if (en) add.push([LANG_PARAM, en.value]);
    }
    var inStock = document.querySelector('input[name="' + AVAIL_PARAM + '"][value="1"]');
    if (inStock && !url.searchParams.has(AVAIL_PARAM) && !off(AVAIL_PARAM)) add.push([AVAIL_PARAM, '1']);
    if (!add.length) return;
    add.forEach(function (kv) { url.searchParams.append(kv[0], kv[1]); });
    location.replace(url.toString());
  }


  // Filters reload the page. Horizon's in-place refresh rewrote the URL but often left the grid
  // and counts unchanged (Sam, 2026-10-05: English on grade-1-languages "did nothing"); a plain
  // navigation to the same URL is always right, so checkbox filters and sorting navigate instead.
  // Filters the page itself already decides (Sam, 2026-10-05, grade-8-math: "we don't need an
  // additional subject filter, AR reading level filter, AR interest band filter"):
  //   grade pages             -> no Subject (the subject chips above do it), no AR level / interest
  //   subject shelves         -> no Subject (site-wide "math", state "esa-az-math")
  //   Accelerated Reader pages-> no AR level / interest;  award pages -> no Awards
  // and anywhere: a group offering a single choice narrows nothing, so it is hidden unless picked.
  var SUBJECT_HANDLES = ['reading-writing', 'math', 'science', 'history-social-studies', 'languages', 'computers-coding',
    'art', 'arts', 'music', 'sports-health-pe', 'life-skills', 'test-prep', 'reference', 'social-studies', 'reading'];
  function hideRedundantFacets() {
    var m = location.pathname.match(/^\/collections\/([^\/?#]+)/);
    if (!m) return;
    var h = m[1], hide = [];
    var SUBJ = 'filter.p.m.esa.subject', ARL = 'filter.p.m.accelerated_reader.level_band',
        ARI = 'filter.p.m.accelerated_reader.interest_band', AW = 'filter.p.m.bookscloud.awards';
    if (/^grade-/.test(h) || /-grade-/.test(h)) hide.push(SUBJ, ARL, ARI);
    if (SUBJECT_HANDLES.some(function (s) { return h === s || h.slice(-(s.length + 1)) === '-' + s; })) hide.push(SUBJ);
    if (/(^|-)ar($|-)|accelerated-reader/.test(h)) hide.push(ARL, ARI);
    if (/award/.test(h)) hide.push(AW);
    document.querySelectorAll('details.facets__panel').forEach(function (d) {
      var inputs = d.querySelectorAll('input[type=checkbox][name^="filter."]');
      if (!inputs.length) return;
      var name = inputs[0].name, picked = false, live = 0;
      inputs.forEach(function (i) { if (i.checked) picked = true; if (!i.disabled) live++; });
      if (picked) return;
      if (hide.indexOf(name) !== -1 || live <= 1) d.style.display = 'none';
    });
  }
  function markNoFilters() {
    if (!document.querySelector('.facets--filters-title')) return;
    if (document.querySelector('input[name^="filter."], [name="filter.v.price.gte"]')) return;
    document.documentElement.classList.add('esa-nofilters');
    // the sidebar column also holds the grade / AR list on state pages: widen the grid only when
    // that column is empty (2026-10-05: widening it pushed esa-tx-awards' grade list to the right)
    var nav = document.querySelector('[data-esa-nav]');
    if (!nav || !nav.querySelector('a')) document.documentElement.classList.add('esa-nofilters-wide');
  }
  function reloadFilters() {
    if (document.documentElement.getAttribute('data-esa-reload')) return;
    document.documentElement.setAttribute('data-esa-reload', '1');
    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.name) return;
      var isBox = t.type === 'checkbox' && t.name.indexOf('filter.') === 0;
      var isSort = t.name === 'sort_by';
      if (!isBox && !isSort) return;
      ev.stopImmediatePropagation();
      var url = new URL(location.href);
      url.searchParams.delete('page');
      if (isSort) {
        url.searchParams.set('sort_by', t.value);
      } else {
        var vals = url.searchParams.getAll(t.name).filter(function (v) { return v !== t.value; });
        if (t.checked) vals.push(t.value);
        url.searchParams.delete(t.name);
        vals.forEach(function (v) { url.searchParams.append(t.name, v); });
        if (!t.checked && (t.name === LANG_PARAM || t.name === AVAIL_PARAM)) {
          try { sessionStorage.setItem('esa.off.' + t.name, '1'); } catch (e) {}
        }
      }
      location.assign(url.toString());
    }, true);
  }

  // Keep the horizontal filter bar on one row: show how many values are picked, not their names.
  function compactFacets() {
    document.querySelectorAll('.facets--horizontal [ref="facetStatus"], .facets-block-wrapper--horizontal [ref="facetStatus"]').forEach(function (el) {
      var t = el.textContent.trim();
      if (!t || /^\d+$/.test(t)) return;
      el.setAttribute('title', t);
      el.textContent = String(t.split(',').length);
      el.classList.add('esa-facet-count');
    });
    // "ENG- English" -> "English"
    document.querySelectorAll('input[name="' + LANG_PARAM + '"]').forEach(function (i) {
      var l = i.id && document.querySelector('label[for="' + i.id + '"] .checkbox__label-text');
      if (l && /^[A-Z]{3}-\s/.test(l.textContent.trim())) l.textContent = l.textContent.trim().replace(/^[A-Z]{3}-\s*/, '');
    });
  }

  // Awards filter: one "Has an award" checkbox instead of hundreds of award names.
  var AWARD_PARAM = 'filter.p.m.bookscloud.awards';
  function awardsCheckbox() {
    document.querySelectorAll('[data-filter-param-name="filter-p-m-bookscloud-awards"]').forEach(function (f) {
      if (f.getAttribute('data-esa-awards')) return;
      var inputs = f.querySelectorAll('input[name="' + AWARD_PARAM + '"]');
      if (!inputs.length) return;
      f.setAttribute('data-esa-awards', '1');
      var url = new URL(location.href);
      var on = url.searchParams.getAll(AWARD_PARAM).length > 0;
      var list = inputs[0].closest('ul');
      if (!list) return;
      var li = document.createElement('li');
      li.className = 'esa-award-filter';
      li.innerHTML = '<label><input type="checkbox"' + (on ? ' checked' : '') + '> <span>Has an award</span></label>';
      list.parentNode.insertBefore(li, list);
      list.style.display = 'none';
      li.querySelector('input').addEventListener('change', function (ev) {
        ev.stopPropagation();
        var u = new URL(location.href);
        u.searchParams.delete(AWARD_PARAM); u.searchParams.delete('page');
        if (this.checked) inputs.forEach(function (i) { u.searchParams.append(AWARD_PARAM, i.value); });
        location.assign(u.toString());
      }, true);
    });
  }

  // The all-products catalog is named for parents.
  function renameCatalog() {
    if (location.pathname.replace(/\/$/, '') !== '/collections/all') return;
    document.querySelectorAll('h1').forEach(function (h) {
      if (h.textContent.trim() === 'Products') h.textContent = 'Books for Your Children';
    });
    if (/^Products/.test(document.title)) document.title = document.title.replace(/^Products/, 'Books for Your Children');
  }


  document.addEventListener('DOMContentLoaded', function () {
    renderPicker(); renderPortal(); renderChip(); refreshBadges(); renderPrograms(); relabelFacets(); initCartMove(); defaultEnglish(); reloadFilters(); hideRedundantFacets(); markNoFilters(); compactFacets(); renameCatalog(); awardsCheckbox(); initNav(); initFreeShip(); restoreCardStash(); showStep2Banner(); window.dispatchEvent(new Event('resize'));
  });
  window.addEventListener('pageshow', function () { refreshBadges(); renderChip(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { refreshBadges(); renderChip(); } });
  document.addEventListener('prerenderingchange', function () { refreshBadges(); renderChip(); });
  window.addEventListener('storage', function (ev) { if (ev.key === KEY) { refreshBadges(); renderChip(); } });
  // the theme editor re-renders a section after each setting change: draw the new copy
  document.addEventListener('shopify:section:load', function () {
    renderPicker(); renderPortal(); renderPrograms(); renderChip(); refreshBadges();
  });
  // re-run badges after sections re-render (Dawn's section rendering API)
  document.addEventListener('shopify:section:load', renderBadges);
  // Horizon re-renders the product grid on filter / sort / paging; badge the new cards.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    requestAnimationFrame(function () { pending = false; renderBadges(); relabelFacets(); compactFacets(); awardsCheckbox(); paintFreeShip(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Student first/last name + grade on orders (snippets/esa-student-fields.liquid), Sam 2026-10-06 */
(function () {
  if (window.ESAKid) return;
  var KEY = 'esa.students';
  function schoolYear() { var d = new Date(); return d.getMonth() >= 7 ? d.getFullYear() : d.getFullYear() - 1; }
  function num(g) { return g === 'pre-k' ? -1 : g === 'k' ? 0 : parseInt(g, 10); }
  function key(n) { return n === -1 ? 'pre-k' : n === 0 ? 'k' : String(n); }
  function label(n) { return n === -1 ? 'Pre-K' : n === 0 ? 'Kindergarten' : 'Grade ' + n; }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function store(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var ESAKid = window.ESAKid = {
    read: function (root) {
      var f = (root.querySelector('[name=studentFirst]') || {}).value || '', l = (root.querySelector('[name=studentLast]') || {}).value || '';
      var g = (root.querySelector('[name=studentGrade]') || {}).value || '';
      f = f.trim(); l = l.trim();
      var classOf = g ? String(schoolYear() + 13 - num(g)) : '';
      return { first: f, last: l, grade: g, classOf: classOf,
        attributes: { student_first_name: f, student_last_name: l, student_name: (f + ' ' + l).trim(), student_grade: g, student_class_of: classOf } };
    },
    remember: function (s) {
      if (!s.first || !s.classOf) return;
      var list = load().filter(function (x) { return !(x.first.toLowerCase() === s.first.toLowerCase() && x.last.toLowerCase() === s.last.toLowerCase()); });
      list.unshift({ first: s.first, last: s.last, classOf: s.classOf });
      store(list.slice(0, 8));
    }
  };
  function init(root) {
    var current = load().filter(function (x) { var n = schoolYear() + 13 - parseInt(x.classOf, 10); return n >= -1 && n <= 12; });
    var wrap = root.querySelector('[data-esa-kid-pickwrap]'), pick = root.querySelector('[data-esa-kid-pick]');
    if (current.length && wrap && pick) {
      current.forEach(function (x, i) {
        var n = schoolYear() + 13 - parseInt(x.classOf, 10), o = document.createElement('option');
        o.value = String(i); o.textContent = x.first + ' ' + x.last + ' (' + label(n) + ')';
        pick.insertBefore(o, pick.lastElementChild);
      });
      wrap.hidden = false;
      pick.addEventListener('change', function () {
        var x = current[parseInt(pick.value, 10)];
        var f = root.querySelector('[name=studentFirst]'), l = root.querySelector('[name=studentLast]'), g = root.querySelector('[name=studentGrade]');
        if (x) { f.value = x.first; l.value = x.last; g.value = key(schoolYear() + 13 - parseInt(x.classOf, 10)); }
        else if (pick.value === 'new') { f.value = ''; l.value = ''; g.value = ''; f.focus(); }
        root.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (root.hasAttribute('data-esa-kid-autosave')) {
      var t;
      root.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var s = ESAKid.read(root);
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: s.attributes }) })
            .then(function () { ESAKid.remember(s); }).catch(function () {});
        }, 400);
      });
    }
  }
  function boot() { document.querySelectorAll('[data-esa-kid]').forEach(function (r) { if (!r.__esaKid) { r.__esaKid = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // the cart drawer re-renders its HTML without running scripts: pick up new fields as they appear
  new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
